import { Base64 } from "models";

export default function fileToBase64 (file: File) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    return new Promise<Base64>((resolve, reject) => {
        reader.onload = () => resolve(reader.result as Base64);
        reader.onerror = error => reject(error)
    })
}